module.exports = __webpack_public_path__ + "static/media/resume.50eb634b.pdf";